import { Geofence } from './geofence.model';
import { Organization } from './organization.model';
import { Project } from './project.model';
import { User } from './user.model';

export enum PunchClockAction {
  ENTER = 'ENTER',
  EXIT = 'EXIT',
}

export interface PunchClock {
  punchClockId: string;
  user: User;
  userId: string;
  project: Project;
  projectId: string;
  organization: Organization;
  organizationId: string;
  action: PunchClockAction;
  time: Date | string;
  createdAt: Date | string;
  /** Set when the punch was triggered by a geofence event from the mobile. */
  geofenceId?: string | null;
  geofence?: Geofence | null;
}
